var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLookupCc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m21.65625 2.0390625 3.392578 5.8789063a12.484178 12.484178 0 0 1 7.945313 11.6191402 12.484178 12.484178 0 0 1-12.484375 12.484375 12.484178 12.484178 0 0 1-10.5976566-6.035156h-3.8261719l-2.9882813-5.175781a17.536913 17.536913 0 0 0 17.4121098 16.263672 17.536913 17.536913 0 0 0 10.478515-3.560547l8.253907 8.253906c0.976266 0.976059 2.558889 0.976059 3.535156 0 0.976059-0.976267 0.976059-2.558889 0-3.535156l-8.251953-8.251953c0.023366-0.031253 0.027801-0.043516 0.048828-0.072266a17.536913 17.536913 0 0 0 3.472656-10.371094 17.536913 17.536913 0 0 0-16.390625-17.4980465z",
    style: {
      fillRule: "evenodd",
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.6019193 2.1544857 5.8339837 10.1054693 5.833984-10.1054693zm-0.865235 0.4980469-5.83398396 10.1054684h11.66796866zm13.3984377 0.0019531-5.833985 10.1035153h11.666016zm-19.23242166 11.1035153 5.83398396 10.105469 5.8339847-10.105469zm13.39843666 0 5.833985 10.103516 5.832031-10.103516zm-0.865234 0.5-5.8339837 10.103516h11.6660147z",
    style: {
      fillRule: "evenodd",
      fill: "#000000"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookupCc);
export default __webpack_public_path__ + "static/media/lookup_cc.f111449412fec1edb5d97dc5e0231abf.svg";
export { ForwardRef as ReactComponent };